import { LicenseStatus } from '@uplift/types';
import { restClient } from '../../client';
import { State } from '../../resources';
import {
  ProviderActivationEvent, ProviderActivationEventName, ProviderActivationStatusDetails
} from '../admin';

export const getProviderActivation = (providerId: string) =>
  restClient.request<{
    data: ProviderActivationStatusDetails;
  }>(`/api/v1/provider/${providerId}/activation`);

export const addProviderActivationEvent = (providerId: string, eventName: ProviderActivationEventName) => restClient.request<{
  data: null;
}>(`/api/v1/provider/${providerId}/activation/events`, {
  method: 'POST',
  data: {
    event_name: eventName,
  }
});

export const getProviderActivationEvents = (providerId: string) =>
  restClient.request<{ data: ProviderActivationEvent[] }>(`/api/v1/provider/${providerId}/activation/events`, {
    method: 'GET',
  });

export type OnboardingTasksStatus = {
  toDo: ProviderActivationEventName[];
  inReview: ProviderActivationEventName[];
  completed: ProviderActivationEventName[];
};

export const getProviderOnboardingTasksStatus = (providerId: string) =>
  restClient.request<{ data: OnboardingTasksStatus }>(`/api/v1/provider/${providerId}/activation/onboarding_tasks_status`, {
    method: 'GET',
  });

export const getProviderLicenseStates = (providerId: string) =>
  restClient.request<{ data: State['shortName'][] }>(`/api/v1/provider/${providerId}/license_states`, {
    method: 'GET',
  });

export const getProviderLicensesStatus = (providerId: string) =>
  restClient.request<{ data: LicenseStatus[] }>(`/api/v1/provider/${providerId}/license/live_status`, {
    method: 'GET',
  });

export const postProviderStatesSelection = (providerId: string, stateIds: string[], setLive = true) =>
  restClient.request<{ data: null }>(`/api/v1/provider/${providerId}/license/set_live`, {
    method: 'POST',
    data: {
      state_ids: stateIds,
      set_live: setLive,
    }
  });
